export const en = {
  translation: {
    noAccess: {
      title: "Access restricted",
      message: "You don't have access to this section.",
    },
    noRestaurant: {
      title: "No restaurant yet",
      message:
        "You don't have access to any restaurant yet. Please contact your administrator to get access.",
      unsubscribed: {
        title: "Your subscription has ended",
        message:
          "Your organization still holds the restaurants below. Open a restaurant's payments to read what you have already paid, or declare a payment to subscribe again.",
        viewPayments: "Payments",
      },
    },
    common: {
      pagination: {
        rowsPerPage: "Rows per page:",
        displayedRows: "{{from}}–{{to}} of {{total}}",
      },
      save: "Save",
      gotIt: "Got it",
      saveChanges: "Save changes",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      email: "email address",
      submit: "Submit",
      tags: "Tags",
      phone: "Phone number",
      days: {
        MONDAY: "Monday",
        TUESDAY: "Tuesday",
        WEDNESDAY: "Wednesday",
        THURSDAY: "Thursday",
        FRIDAY: "Friday",
        SATURDAY: "Saturday",
        SUNDAY: "Sunday",
      },
      months: {
        1: "January",
        2: "February",
        3: "March",
        4: "April",
        5: "May",
        6: "June",
        7: "July",
        8: "August",
        9: "September",
        10: "October",
        11: "November",
        12: "December",
      },
      error: "An error occured please try again",
      noData: "No data for this period",
    },
    emailVerification: {
      body: "Your account if being verified please wait for a few seconds",
      crash: "An error occurred, please try again in a while",
      website: {
        success:
          "Your account was verified successfully, you will be redirected to Sign In",
        error:
          "Your token is unfortunately expired, please try again from the Sign In screen",
      },
      mobile: {
        success:
          "Your account was verified successfully, you can now sign in from the mobile app",
        error:
          "Your token is unfortunately expired, please try again from the mobile app",
      },
    },
    landingPage: {
      nav: {
        ecosystem: "Ecosystem",
        features: "Features",
        analytics: "Analytics",
        pricing: "Pricing",
        requestDemo: "Request a demo",
        openMenu: "Open menu",
      },
      hero: {
        title: "The only tool that brings you customers — and fills your dining room.",
        subtitle:
          "L'Addition connects thousands of diners from our app to your restaurant, then brings reservations, floor plan, offers, menu and analytics together in one platform.",
        cta: "Request a demo",
        secondaryCta: "See features",
      },
      ecosystem: {
        title: "An ecosystem that works both ways.",
        subtitle:
          "Your customers book from the app or from your dedicated booking page; your offers and events appear there — everything flows between the consumer app and your dashboard.",
        appTag: "📱 The app",
        bookingPageTag: "🔗 Your own dedicated booking page",
        caption:
          "Your customers book from the app or from your own dedicated booking page — hosted by us. The offers and events you create in your dashboard appear there instantly, in front of thousands of diners.",
        appScreenAlt: "L'Addition app — booking screen",
        bookingPage: {
          url: "laddition.ma/booking/Casa",
          restaurantName: "Your restaurant",
          chooseDate: "Choose a date",
          chooseDateSub: "Pick from our available dates",
          legendAvailable: "Available",
          legendOffer: "Offer",
          legendEvents: "Events",
          month: "May 2026",
        },
        dashboard: {
          restaurantSelector: "L'Atelier — Casablanca · Downtown",
          date: "Friday 15 May 2026",
          greeting: "Hello, Karim",
          greetingSub: "Here is your restaurant's activity today.",
          generalStats: "General statistics",
          bookings: "Reservations",
          covers: "Covers",
          occupancy: "Occupancy",
          bookingsToday: "Today's reservations",
          bookingsTodaySub: "Friday 15 May · 78 covers",
          seeAll: "See all →",
          confirmed: "Confirmed",
          quietSlots: "Off-peak slots",
          quietSlotsSub: "Tables occupied per slot · today's service",
          quietMessage: "15:00 → 18:00 is almost empty.",
          quietMessageEnd: " An offer can fill those tables.",
          quietCta: "Create an offer",
          offersEvents: "Offers & Events",
          offersEventsSub: "What shows up in the app",
          create: "+ Create",
          liveMusic: "Live music",
          liveMusicTag: "Event · Fri. 9pm",
          happyHour: "−20% happy hour",
          happyHourTag: "Offer · 6pm–8pm",
        },
      },
      showcase: {
        title: "30+ features, one single screen.",
        subtitle:
          "Reservations, floor plan, offers, menu, analytics, team… your whole restaurant on a single platform.",
        bookings: {
          tab: "Real-time reservations",
          title: "Real-time reservations",
          description:
            "Receive, confirm and track every reservation live, whatever the channel — and keep no-shows under control with WhatsApp confirmation and a blacklist.",
          checks: {
            whatsapp: "One-click customer confirmation via WhatsApp",
            blacklist: "Blacklist repeat no-show customers to protect your tables",
            statuses: "Live statuses: confirmed, arrived, no-show",
            views: "Today, upcoming and history views",
          },
        },
        offPeak: {
          tab: "Off-peak hours",
          title: "Turn your off-peak hours into revenue",
          description:
            "Create an offer targeting your empty slots and push it into the app. L'Addition then measures how many covers actually landed in the targeted window — not elsewhere.",
          checks: {
            oneClick: "Offers and events activatable in one click",
            visualize: "See tables occupied by time slot",
            impact: "Track each offer's real impact on covers",
          },
          coversPerSlot: "Covers per slot",
          targetWindow: "Targeted window",
        },
        floorPlan: {
          tab: "Floor plan",
          title: "Floor plan & daily grid",
          description:
            "A visual grid of your room: drag each reservation onto its table, hour by hour, never double-booking.",
          checks: {
            dragDrop: "Drag-and-drop reservations onto tables",
            noDoubleBooking: "Slot-by-slot view, no double-booking",
            unassigned: "Unassigned reservations at a glance",
          },
        },
        analytics: {
          tab: "Advanced analytics",
          title: "Advanced analytics",
          description:
            "Every service feeds a clear dashboard: occupancy rate, peak hours, group size and performance by day.",
          checks: {
            trend: "Reservation trend and peak hours",
            breakdown: "Breakdown by group size and by day",
            offerImpact: "Quantified impact of every offer and event",
          },
          occupancyRate: "Occupancy rate",
          coversPerWeek: "Covers / week",
          avgPartySize: "Average group size",
          bestDay: "Best day",
          bestDayValue: "Friday",
        },
        menu: {
          tab: "Menu & QR Code",
          title: "Menu & QR Code",
          description:
            "Manage your dishes and categories, highlight your signatures, and share your digital menu via a QR code at the table.",
          checks: {
            editable: "Dishes, categories and prices editable anytime",
            signature: "Highlight your signature dishes",
            qrCode: "Menu shareable via QR code",
            published: "Menu published directly in the L'Addition app",
          },
          dishes: {
            salad: "Caesar salad",
            tajine: "Signature tajine",
            dessert: "Chocolate fondant",
          },
        },
        gallery: {
          tab: "Gallery & visibility",
          title: "Gallery & visibility",
          description:
            "Cover photo, restaurant and menu galleries: polish the page your future customers see before booking.",
          checks: {
            galleries: "Cover photo and restaurant + menu galleries",
            storefront: "An attractive storefront in the app",
            seasonal: "Updated along with your seasonal offers",
          },
          alts: {
            diningRoom: "Restaurant dining room",
            setTable: "Set table",
            ambience: "Restaurant ambience",
          },
        },
        team: {
          tab: "Team & multi-restaurant",
          title: "Team & multi-restaurant",
          description:
            "Invite your staff, assign precise roles, and manage several venues from a single account.",
          checks: {
            roles: "Dedicated roles and access per member",
            switch: "Switch between venues in one click",
            centralized: "Centralized management for groups",
          },
          roles: {
            manager: "Manager",
            receptionist: "Receptionist",
            waiter: "Waiter",
            venues: "2 venues",
          },
        },
      },
      analyticsSection: {
        title: "Make data-driven decisions",
        subtitle:
          "Real-time dashboards giving you a complete view of your business.",
        bookings: "Reservations",
        guests: "Guests",
        fillRate: "Fill rate",
        growthRate: "Growth rate",
        vsLastMonth: "↗ vs last month",
        bookingsTrend: "Reservation trend",
        bookingsTrendAlt: "Reservation trend over the week",
        bookingsByHour: "Bookings by service hour",
        offersPerformance: "Your offers' performance",
        eventsPerformance: "Your events' performance",
        offerColumn: "Offer",
        coversColumn: "Covers",
        deltaColumn: "Δ",
        days: {
          mon: "Mon",
          tue: "Tue",
          wed: "Wed",
          thu: "Thu",
          fri: "Fri",
          sat: "Sat",
          sun: "Sun",
        },
        shortDays: {
          mon: "Mo",
          tue: "Tu",
          wed: "We",
          thu: "Th",
          fri: "Fr",
          sat: "Sa",
          sun: "Su",
        },
      },
      clientApp: {
        title: "Your real edge: an app that brings you customers.",
        subtitle:
          "L'Addition is the only platform in Morocco backed by a consumer app. Your daily deals and events appear there in front of thousands of diners — and turn into covers.",
        checks: {
          discover: "Discover restaurants, rooftops and top spots by city",
          deals: "Your daily deals in the “Tonight” section",
          events: "Your events & experiences bookable in two taps",
          favorites: "Favorites, reviews and sharing with friends",
        },
        downloadOn: "Download on",
        appStore: "App Store",
        availableOn: "Available on",
        googlePlay: "Google Play",
        screenshotAlt:
          "L'Addition app — map of restaurants and deals in Casablanca",
      },
      steps: {
        title: "Up and running in 24h, in three steps.",
        one: {
          title: "Create your space",
          body: "Add your restaurant: name, address, capacity, hours. A few minutes is enough.",
        },
        two: {
          title: "Set up menu & room",
          body: "Import your menu, draw your floor plan and publish your photo gallery.",
        },
        three: {
          title: "Ready in 24h",
          body: "In under 24h, your account is set up and ready to take reservations. You manage them live and your offers fill the off-peak hours.",
        },
      },
      pricing: {
        title: "Two modules, clear pricing.",
        subtitle:
          "Choose based on your restaurant. No commission on your covers — you keep 100% of your revenue.",
        firstMonthFree: "🎁 First month free",
        cta: "Get started",
        multi: {
          title: "Do you manage several restaurants?",
          body: "Chains, groups and hotels: manage all your venues from a single account, with dedicated roles and tailored support.",
          cta: "Let's talk",
        },
      },
      faq: {
        title: "What we get asked most.",
        modules: {
          q: "What's the difference between the Visibility and Reservation modules?",
          a: "“Visibility” fills your off-peak services day by day with deals published in the app — ideal for walk-ins. “Reservation” adds future-date bookings, the floor plan and bookable events & experiences. The Reservation module includes everything in Visibility.",
        },
        setup: {
          q: "How long to get up and running?",
          a: "Most restaurants are ready to take reservations in under 24h: info, hours, menu and floor plan. Our team helps import your menu.",
        },
        whatsapp: {
          q: "How does WhatsApp confirmation work?",
          a: "From each reservation, you confirm the customer in one click on WhatsApp. It's the most-used channel in Morocco, which strongly reduces no-shows.",
        },
        commission: {
          q: "Do you take a commission on my reservations?",
          a: "No. L'Addition is a fixed monthly subscription. You keep 100% of your covers' revenue, offers included.",
        },
        multiRestaurant: {
          q: "Can I manage several restaurants?",
          a: "Yes. You switch between venues from a single account, with dedicated roles and access for each team.",
        },
        offPeak: {
          q: "What are “off-peak hours” and offers?",
          a: "Your dashboard spots the emptiest time slots. You attach an offer pushed into the L'Addition app, then measure the covers actually gained in that slot.",
        },
        commitment: {
          q: "Is there a commitment?",
          a: "None. The subscription is monthly and cancelable anytime from your account.",
        },
      },
      demo: {
        title: "Your tables are waiting.",
        subtitle:
          "Join the Casablanca restaurants filling their rooms with L'Addition. Request a demo, we handle the rest.",
        fields: {
          managerName: "Manager's name",
          email: "Email",
          phone: "Phone",
          restaurantName: "Restaurant name",
          city: "City",
          howDidYouHear: "How did you hear about us?",
          message: "Message (optional)",
        },
        cityOptions: {
          casablanca: "Casablanca",
          rabat: "Rabat",
          marrakech: "Marrakech",
          fes: "Fès",
          tanger: "Tangier",
          agadir: "Agadir",
          other: "Other",
        },
        hearOptions: {
          socialMedia: "Instagram",
          friend: "Referral",
          google: "Google search",
          event: "Event",
          other: "Other",
        },
        cta: "Request a Demo",
        success: "Your request has been sent successfully!",
        error: "An error occurred, please try again",
        errorEmailTaken:
          "This email address is already linked to an existing request.",
        errorPhoneTaken:
          "This phone number is already linked to an existing request.",
      },
      subscriptionTiers: {
        buttonLabel: "Choose your subscription",
        buttonSelected: "Plan: {{- tier}}",
        modalTitle: "Choose your plan",
        modalSubtitle: "Pick the plan that best fits your restaurant.",
        popular: "Most popular",
        priceSuffix: "MAD / mo. excl. tax",
        annualRate: "{{amount}} MAD/mo. billed annually",
        selectCta: "Choose this plan",
        selectedCta: "Selected",
        required: "Please choose a subscription plan",
        loadError: "Unable to load modules. Please try again.",
        tiers: {
          visibilite: {
            title: "Visibility — Offers & Events",
            description: "Fill your off-peak services.",
          },
          reservation: {
            title: "Reservation",
            description: "Everything in the Visibility module, plus:",
          },
        },
      },
      footer: {
        tagline:
          "The discovery and management platform for restaurants in Morocco. A VastTech product, Casablanca.",
        product: "Product",
        features: "Features",
        analytics: "Analytics",
        pricing: "Pricing",
        company: "Company",
        requestDemo: "Request a demo",
        contact: "Contact us",
        instagram: "@laddition_maroc",
        legal: "Legal",
        legalNotice: "Legal notice",
        privacy: "Privacy",
        terms: "Terms",
        googlePlay: "Google Play",
        appStore: "App Store",
        copyright: "© 2026 L'Addition · VastTech SARL, Casablanca.",
        madeIn: "Made in Morocco 🇲🇦",
      },
    },
    homePage: {
      header: "Attract more customers",
      secondHeader: "Increase your trafic",
      subheader:
        "With L'addition, <strong>manage your restaurant's reservations</strong>, <strong>offer deals</strong> to customers, and <strong>increase your online visibility</strong>, all in one environment!",
      discoverCta: "Discover",
      comingSoon: "Coming soon",
    },
    footer: {
      about: "About",
      termsAndConditions: "Terms and conditions",
      contact: "Contact",
      downloadTheApp: "Download the App for customers :",
      phone: "Phone: {{phone}}",
    },
    profileDropDown: {
      changePassword: "Change my password",
      logout: "Logout",
      emailSent: "An email has been sent, please check your inbox",
    },
    About: "About",
    signIn: {
      cta: "Login",
      dashboard: "My Dashboard",
      header: "Hey, Welcome Back!",
      subHeader: "Enter your credentials to access your account",
      email: "Email Address",
      password: "Password",
      rememberMe: "Remember me",
      forgotPassword: "Forgot your password?",
      noAccount: "Don't have an account?",
      errors: {
        credentialsMissing: "Please fill all the fields",
        credentialsInvalid: "The email or password is incorrect",
        notVerified: "Your account hasnt been verified please check your email",
        wrongAccountType:
          "This account is not a restaurant owner account, please sign in from the mobile app",
      },
    },
    signUp: {
      cta: "Sign Up",
      header: "Create your account",
      subheader:
        "Sign Up Now Enter your information to create your account and start managing your restaurants with ease. Take advantage of our platform to increase customer traffic and optimize your establishment's management.",
      createAccount: "Submit my request",
      creationSuccess:
        "Your request was successfully submitted, we will review it and get back to you as soon as possible",
      creationError: "An error occurred while creating your request",
      emailTaken: "This email is already taken",
      form: {
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email Address",
        phone: "Phone Number",
        restaurantName: "Restaurant Name",
        city: "City",
      },
    },
    booking: {
      header: "Book a table",
      subheader:
        "Book a table at <strong>{{restaurant_name}}</strong> for a unique dining experience",
      form: {
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email Address",
        phone: "Phone Number",
        numberOfPeople: "Number of people",
        submit: "Continue",
        book: "Book",
        cancel: "Cancel",
      },
      creationSuccessHeader: "Booking request sent",
      creationSuccessHelper:
        "{{restaurant_name}} has received your booking request, they will contact you to confirm your reservation",
      creationError:
        "An error occurred while creating your booking, please try again",
      slotsFull:
        "It seems like someone else just booked this slot, please choose another one",
    },
    clientBooking: {
      selectDate: "Select a Date",
      selectDateSubtitle: "Choose from our available dates below",
      available: "Available",
      specialDeal: "Special Deal",
      selectTime: "Select a Time",
      back: "Back",
      morning: "Morning",
      evening: "Evening",
      numGuests: "Number of Guests",
      numGuestsSubtitle: "How many people will be dining?",
      guests: "Guests",
      quickSelect: "Quick select:",
      continueCta: "Continue",
      largePartyNote:
        "For parties larger than {{max}} guests, please call us at {{phone}}",
      largePartyNoteNoLimit:
        "For large parties, please call us at {{phone}}",
      yourDetails: "Your Details",
      completeReservation: "Complete your reservation",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      phone: "Phone Number",
      specialRequests: "Special Requests (Optional)",
      specialRequestsPlaceholder:
        "Allergies, dietary restrictions, special occasions...",
      confirmReservation: "Confirm Reservation",
      openHours: "Open: {{hours}}",
      reviews: "{{count}} reviews",
      offDiscount: "{{discount}}% off",
      guestCountSummary: "{{count}} Guests",
      required: "This field is required",
      invalidEmail: "Please enter a valid email address",
      bookingSuccess: "Booking Confirmed!",
      bookingSuccessMessage:
        "Your reservation at {{restaurant}} has been confirmed. We look forward to welcoming you!",
      bookingError: "An error occurred, please try again",
      errorLoading: "Failed to load restaurant information. Please try again.",
      restaurantNotFound: "This restaurant doesn't exist.",
      notAcceptingBookings: "This restaurant is not accepting online bookings yet.",
    },
    publicMenu: {
      priceNote: "Prices in dirhams · Service included",
      itemPrice: "{{price}} DH",
      restaurantNotFound: "This restaurant doesn't exist.",
      errorLoading: "Failed to load the restaurant's menu. Please try again.",
    },
    AboutPage: {
      Mission: {
        Header: "Our Mission",
        Body: "At <strong>L'Addition</strong> we aim to revolutionize and enrich the fine dining industry in <strong>Morocco</strong> by connecting passionate restaurant owners and eager customers.\n\nWe believe in fostering a vibrant culinary community, where <strong>every restaurant has the opportunity to shine</strong>, and every diner can discover their next favorite spot.\n\nLeverage the power of the internet to put your restaurant at the center of attention and in the hearts of your customers.",
      },
      Services: {
        Header: "Our Services",
        Body: "Welcome to <strong>L'Addition</strong>, the new online platform for <strong>restaurant owners in Morocco</strong> to showcase their establishments and manage their reservation services.\n\nCreate your account right now to register your restaurants and effortlessly manage everything from your schedules and menus all the way to your deals and reservations.",
        Restaurants: {
          Header: "Restaurant Management",
          Body: "You can register and manage <strong>as many restaurants as you want</strong> to put them on the map.\n\nHave <strong>full control</strong> over their respective schedules, menus, deals etc...",
        },
        Calendar: {
          Header: "Calendar Management",
          Body: "Set up a calendar of opening and closing hours to keep customers informed on your typical week.\n\nAdd leave days in the calendar to manage any unplanned constructions or vacations.",
        },
        Menu: {
          Header: "Menu Management",
          Body: "You can make your menu available to all your customers, whether through plain text, images or both.\n\nMake any changes you require whenever you want and however you want.",
        },
        Deals: {
          Header: "Deals Management",
          Body: "Feeling like offering alluring deals to your customers? Set up some deals with custom description and effortlessly switch them on or off for each restaurant.",
        },
        Reservations: {
          Header: "Reservations Management",
          Body: "The core service of the platform is the ability to manage all your future reservations while keeping an eye on the past ones as well.",
        },
      },
    },
    contactPage: {
      header:
        "Facing an issue with our website? let us know by creating a ticket",
      subHeader: "Our teams will do their best to solve your issue asap",
      form: {
        content: "Describe your problem",
      },
    },
    featureLocked: {
      upgrade: {
        title: "{{feature}} is not in your plan",
        message:
          "Your subscription does not include {{feature}} for this restaurant. Upgrade to unlock it.",
        action: "Go to payment",
      },
      permission: {
        title: "{{feature}} is restricted",
        message:
          "Ask your organization administrator to grant you access to {{feature}}.",
      },
    },
    dashboard: {
      seeAll: "See all",
      details: "Details",
      manage: "Manage",
      edit: "Edit",
      features: {
        bookings: "Bookings",
        analytics: "Analytics",
        deals: "Deals and events",
        restaurantInfo: "Restaurant info",
      },
      sections: {
        generalStats: "General statistics",
        today: "Today",
        offersAndInfo: "Offers & restaurant info",
      },
      header: {
        greeting: "Hello, {{name}}",
        greetingFallback: "Hello",
        activity: "Here is {{restaurant}}'s activity today.",
        pending_one: "One booking is waiting for your confirmation.",
        pending_other: "{{count}} bookings are waiting for your confirmation.",
        noPending: "Every booking is confirmed.",
        noBookings: "No bookings today.",
      },
      subscription: {
        plan: "Subscription",
        nextBilling: "Next invoice",
        manage: "Manage",
        none: "No plan",
      },
      stats: {
        todaysBookings: "Bookings today",
        expectedGuests: "Expected guests",
        occupancy: "Occupancy rate",
        vsLastWeek: "vs last week",
      },
      todaysBookings: {
        title: "Today's bookings",
        subtitle: "{{date}} · {{count}} guests",
        empty: "No bookings today yet.",
      },
      quietSlots: {
        title: "Quiet slots",
        subtitle: "Tables held per hour · today's service",
        callout:
          "{{start}} → {{end}} is running almost empty. An offer could fill those tables.",
        createOffer: "Create an offer",
        emptyService:
          "No bookings yet today. An offer could get the service started.",
        noQuietWindow: "No quiet stretch today — the service fills up evenly.",
        closed: "The restaurant is closed today.",
        noSchedule: "No opening hours set for today.",
      },
      analytics: {
        title: "Analytics",
        subtitle: "Last {{days}} days · bookings & guests",
        bookings: "Bookings",
        guests: "Guests",
        bookingsCount_one: "{{count}} booking",
        bookingsCount_other: "{{count}} bookings",
        trendTitle: "Bookings trend",
        peakHours: "Peak hours",
      },
      offers: {
        title: "Offers & events",
        subtitle:
          "{{deals}} active deals · {{events}} active events · {{total}} in total",
        deal: "Deal",
        event: "Event",
        active: "Active",
        inactive: "Inactive",
        empty: "No offers or events yet.",
      },
      restaurantInfo: {
        title: "Restaurant info",
        address: "Address",
        phone: "Phone",
        today: "Today",
        open: "Open",
        closedToday: "Closed today",
      },
    },
    // Every line of a pricing card: the catalog hands over the key, not the
    // sentence, so a re-worded or re-sold perk is a translation change alone.
    subscription: {
      perk: {
        deals: {
          publish_offers: "Publish your deals in our consumer app",
          publish_events: "Publish your events in our consumer app",
          recurring_automatic: "Automatic recurring offers",
        },
        booking: {
          same_day: "Manage today's bookings",
          full_management: "Complete reservation management system",
          floor_plan: "Floor plan & table management",
          no_show_blacklist: "No-show blacklist",
        },
        analytics: {
          offers:
            "Analytics on your offers — covers generated, conversion, party size, best slot",
          full: "Full analytics — fill rate, peak hours, customer recurrence, unlimited history",
        },
        menu: {
          hosted_page:
            "Manage your menu and generate a dedicated page, hosted free of charge",
        },
        staff: {
          three_accounts: "3 user accounts",
          unlimited_accounts_and_roles: "Unlimited accounts and roles",
        },
        service: {
          live_view: "Live current-service view",
        },
        boost: {
          one_per_month: "1 free boost per month",
        },
        support: {
          whatsapp_7_7: "WhatsApp support 7/7",
        },
      },
    },
    payments: {
      pageTitle: "Payments",
      pageSubtitle:
        "Declare the transfer you made, follow its review, and see everything you have paid so far.",
      loadError: "Unable to load your payments. Please try again.",
      amount: "{{amount}} MAD",
      months_one: "{{count}} month",
      months_other: "{{count}} months",
      type: {
        RENEWAL: "Renewal",
        UPGRADE: "Upgrade",
      },
      period: {
        MONTHLY: "Monthly",
        ANNUAL: "Annual",
      },
      status: {
        PENDING: "Awaiting review",
        CONFIRMED: "Confirmed",
        REJECTED: "Rejected",
        CANCELLED: "Cancelled",
      },
      pending: {
        title: "Payment awaiting review",
        subtitle:
          "We are checking your transfer. You cannot declare another payment until this one is resolved.",
        declaredOn: "Declared on {{date}}",
        downloadProof: "Download proof",
        replaceProof: "Replace proof",
        cancel: "Cancel payment",
      },
      replace: {
        title: "Replace the proof of transfer",
        body: "Upload a corrected proof. It replaces the one attached to this payment.",
        submit: "Replace",
        cancel: "Cancel",
      },
      cancel: {
        title: "Cancel this payment?",
        body: "The payment stays in your history as cancelled, and you are free to declare a corrected one.",
        confirm: "Cancel the payment",
        dismiss: "Keep it",
      },
      history: {
        title: "Payment history",
        subtitle: "Every payment you have declared, most recent first",
        download: "Download proof",
        rejectionReason: "Reason: {{reason}}",
        columns: {
          date: "Date",
          type: "Type",
          tier: "Plan",
          duration: "Duration",
          amount: "Amount",
          status: "Status",
          proof: "Proof",
        },
        empty: {
          title: "No payment yet",
          message: "Declare your first transfer and it will appear here.",
        },
      },
      declare: {
        title: "Declare a payment",
        subtitle:
          "Make the transfer to the account below, then attach the proof. We confirm it once the transfer lands.",
        typeLabel: "What are you paying for",
        tierLabel: "Plan",
        periodLabel: "Billing period",
        perMonth: "{{amount}} MAD/month",
        savePercent: "-{{percent}}%",
        saveAmount: "You save {{amount}} MAD over the year",
        periodDuration: "{{period}} · {{duration}}",
        durationLabel: "Duration",
        amountLabel: "Expected amount",
        amountHint:
          "Shown from the catalogue price. The final amount is the one recorded on your payment.",
        submit: "Declare the payment",
        cancel: "Cancel",
        renewAction: "Declare a payment",
        upgradeAction: "Request an upgrade",
        highestTier: "You are already on the highest plan.",
      },
      bank: {
        title: "Bank transfer details",
        subtitle: "Where to send the transfer",
        accountHolder: "Account holder",
        rib: "RIB",
        swift: "SWIFT code",
        iban: "IBAN",
        ibanHint: "Use it for transfers sent from outside Morocco.",
        reference: "Transfer reference",
        referenceHint: "Put this in the transfer reference so we can match it.",
        copy: "Copy the RIB",
        copied: "RIB copied to the clipboard",
      },
      proof: {
        label: "Proof of transfer",
        choose: "Attach a file",
        accepted: "JPEG, PNG, HEIC or PDF, up to {{size}} MB.",
        errors: {
          tooLarge: "This file is larger than {{size}} MB. Please attach a smaller one.",
          unsupportedType: "Only JPEG, PNG, HEIC and PDF files are accepted.",
        },
      },
      errors: {
        missingProof: "A proof of transfer and a payment type are required.",
        forbidden: "You are not allowed to manage this restaurant's payments.",
        notFound: "This restaurant could not be found.",
        alreadyPending:
          "A payment is already awaiting review for this restaurant, or this one is no longer pending.",
        tooLarge: "The proof exceeds the maximum size of {{size}} MB.",
        unsupportedType: "The proof must be a JPEG, PNG, HEIC or PDF file.",
        invalidTier: "This plan is not a valid choice for this payment.",
        generic: "Something went wrong. Please try again.",
      },
      admin: {
        title: "Payments",
        subtitle: "Review declared transfers and apply them to subscriptions",
        queueTitle: "Payment queue",
        queueSubtitle: "Most recent first",
        loadError: "Failed to load payments",
        resolvedBy: "Resolved by {{admin}}",
        filter: {
          label: "Status",
          all: "All statuses",
        },
        columns: {
          restaurant: "Restaurant",
          actions: "Actions",
        },
        empty: {
          title: "Nothing here",
          message: "No payment matches this filter.",
        },
        actions: {
          preview: "View the proof",
          confirm: "Confirm",
          reject: "Reject",
        },
        proof: {
          title: "Proof of transfer",
          close: "Close",
          downloaded:
            "This proof cannot be previewed in the browser and has been downloaded instead.",
        },
        confirm: {
          title: "Confirm {{restaurant}}'s payment",
          body: "Change a field only to correct what was declared. Untouched fields keep their declared value.",
          renewalConsequence:
            "Confirming extends this restaurant's subscription. There is no step after this one.",
          upgradeConsequence:
            "Confirming grants the target plan from today and discards the remaining cycle. There is no step after this one.",
          period: "Billing period",
          months: "Months",
          tier: "Plan",
          amount: "Amount",
          submit: "Confirm payment",
          cancel: "Cancel",
          success: "{{restaurant}}'s payment has been confirmed.",
          failed: "Failed to confirm the payment",
        },
        reject: {
          title: "Reject {{restaurant}}'s payment",
          body: "The reason is shown to the restaurateur, and rejecting frees them to declare a corrected payment. It does not touch the subscription.",
          reason: "Reason",
          submit: "Reject payment",
          cancel: "Cancel",
          success: "{{restaurant}}'s payment has been rejected.",
          failed: "Failed to reject the payment",
        },
      },
    },
    sideBar: {
      dashboard: "Dashboard",
      mydashboard: "Dashboard",
      myRestaurants: "My Restaurants",
      restaurantInfo: "Restaurant Info",
      openingHours: "Opening Hours",
      mediaGallery: "Media Gallery",
      menuManagement: "Menu Management",
      menu: "Menu",
      bookings: "Bookings",
      tableSchedule: "Table Schedule",
      statistics: "Analytics",
      deals: "Deals & Events",
      logout: "Logout",
      selectRestaurant: "Select a restaurant",
      myOrganization: "My Organization",
      adminControlPanel: "Admin Control Panel",
      configuration: "Configuration",
      payments: "Payments",
    },
    staffInvitation: {
      title: "Join your team",
      subtitle: "Complete your details to set up your staff account.",
      fields: {
        firstName: "First name",
        lastName: "Last name",
        phone: "Phone number",
        password: "Password",
        confirmPassword: "Confirm password",
      },
      cta: "Create my account",
      success:
        "Your account has been created. You can now log in with your email and password.",
      goToLogin: "Go to login",
      error: "Something went wrong. Please try again.",
      errorPasswordMismatch: "The passwords do not match.",
      errorInvalidLink: "This invitation link is invalid or has expired.",
    },
    subscriptionBanner: {
      title: "Subscription expired",
      renewNow: "Renew now",
      message_one:
        "{{restaurant}}'s subscription has run out. Access will be revoked automatically in {{count}} day. Contact your administrator to renew it.",
      message_other:
        "{{restaurant}}'s subscription has run out. Access will be revoked automatically in {{count}} days. Contact your administrator to renew it.",
      messageToday:
        "{{restaurant}}'s subscription has run out. Access will be revoked automatically today. Contact your administrator to renew it.",
      messageUnknown:
        "{{restaurant}}'s subscription has run out and access will be revoked automatically. Contact your administrator to renew it.",
      expiredOn: "Expired on {{date}}",
    },
    configuration: {
      pageTitle: "Configuration",
      pageSubtitle: "Manage your subscription and account settings",
      subscription: {
        title: "Subscription",
        subtitle: "Your current plan and billing preferences",
        current: "Current",
        loadError: "Unable to load your subscription details",
        noTier: "This restaurant doesn't have a subscription tier yet.",
        nextBillingTitle: "Next billing date",
        nextBillingSubtitle: "Your subscription renews on this date",
        renewTitle: "Renew your plan",
        renewSubtitle: "Declare the transfer that pays for your next billing period",
        upgradeTitle: "Upgrade plan",
        upgradeSubtitle: "Unlock multi-location management and advanced analytics",
        renew: "Renew my payment",
        upgrade: "Upgrade",
        cancelTitle: "Cancel subscription",
        cancelSubtitle: "Unsubscribing ends this restaurant's subscription and closes its dashboard",
        unsubscribe: "Unsubscribe",
        comingSoon: "Coming soon",
        unsubscribeConfirmTitle: "Unsubscribe this restaurant?",
        unsubscribeConfirmBody: "This ends the subscription immediately and closes the restaurant's dashboard. The restaurant stays in your organization with its payment history, and you can subscribe again by declaring a payment.",
        unsubscribeConfirm: "Unsubscribe",
        unsubscribeCancel: "Cancel",
        unsubscribeSuccess: "The subscription has ended. The restaurant stays in your organization — declare a payment to subscribe again.",
        unsubscribeError: "Failed to unsubscribe. Please try again.",
      },
      account: {
        title: "Account Details",
        subtitle: "Your personal information and contact details",
        edit: "Edit Profile",
        save: "Save",
        cancel: "Cancel",
        fullName: "Full Name",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email Address",
        phone: "Phone Number",
        updateSuccess: "Profile updated",
        updateError: "Failed to update profile",
      },
      password: {
        title: "Password & Security",
        subtitle: "Manage your password and account security",
        label: "Password",
        resetHint: "A reset link will be sent to {{email}}",
        sendReset: "Send Reset Email",
        resetSuccess: "Password reset email sent",
        resetError: "Failed to send reset email",
      },
    },
    myOrganization: {
      pageTitle: "My Organization",
      pageSubtitle: "Manage your organization's staff and roles",
      summary: {
        title: "Organization Overview",
        staff: "Staff Members",
        roles: "Roles",
        restaurants: "{{count}} restaurant(s)",
      },
      tabs: {
        staff: "My Staff",
        roles: "Staff Roles",
      },
      staff: {
        pageTitle: "Staff Members",
        unlimited: "unlimited",
        searchPlaceholder: "Search by name or email…",
        noStaff: "No staff members found",
        noResults: "No staff match your search",
        name: "Name",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        phone: "Phone",
        role: "Role",
        restaurants: "Assigned Restaurants",
        invite: "Invite",
        inviteTitle: "Invite a staff member",
        inviteSubtitle:
          "We'll email them a secure link to set up their account.",
        inviteEmail: "Email address",
        inviteRestaurant: "Assign to restaurant",
        inviteSend: "Send invitation",
        inviteSuccess: "Invitation sent",
        inviteError: "Failed to send invitation",
        inviteEmailInvalid: "Please enter a valid email address",
        inviteSelectRestaurant: "Please select a restaurant",
      },
      staffView: {
        pageTitle: "Staff Member",
        back: "Back",
        updateSuccess: "Staff member updated successfully",
        updateError: "Failed to update staff member",
        deleteSuccess: "Staff member deleted",
        deleteError: "Failed to delete staff member",
        deleteConfirmTitle: "Delete Staff Member",
        deleteConfirmBody: "Are you sure you want to delete {{name}}? This action cannot be undone.",
        saveChanges: "Save Changes",
        delete: "Delete",
        assignRole: "Assigned Role",
        changeRole: "Change Role",
      },
      roles: {
        pageTitle: "Staff Roles",
        createRole: "Create Role",
        noRoles: "No roles created yet",
        name: "Role Name",
        description: "Description",
        descriptionPlaceholder: "Optional description",
        permissions: "Permissions",
        createSuccess: "Role \"{{name}}\" created",
        deleteSuccess: "Role \"{{name}}\" deleted",
        deleteConfirmTitle: "Delete Role",
        deleteConfirmBody: "Are you sure you want to delete the role \"{{name}}\"? Staff assigned to this role may be affected.",
      },
      roleView: {
        pageTitle: "Role",
        back: "Back",
        permissions: "Permissions",
        noPermissions: "No permissions available for this organization",
        selectedCount: "{{count}} of {{total}} permissions selected",
        saveChanges: "Save Changes",
        updateSuccess: "Role permissions updated successfully",
        updateError: "Failed to update role permissions",
      },
    },
    restaurant: {
      home: {
        header: "Welcome {{name}}!",
        kpi: {
          day: "Today",
          twoDays: "These 2 days",
          week: "This week",
          month: "This month",
          year: "This year",
          twoWeeks: "These 2 weeks",
          ownerRanking: "Your ranking within the app",
          ownerRankingDesc: "Most visited this week",
          bookingsByCity: "Distribution of visitors",
          bookings: "Number of Reservations",
          visitors: "Number of visitors",
        },
        bookingsHeader: "Future bookings",
        noBookings: "You have no incoming bookings",
        dealsHeader: "Active deals",
        seeAll: "See all",
        seeStats: "See all statistics",
      },
      restaurantList: {
        header: "Your Restaurants",
        restaurantName: "Restaurant Name",
        city: "City",
        address: "Address",
        rowsPerPage: "Rows per page",
      },
      addRestaurantPage: {},
      capabilities: {
        header: "Capabilities",
        subheader: "Features and permissions enabled for this restaurant",
        manage: "Manage",
        noCapabilities: "No capabilities assigned",
        drawer: {
          title: "Add Capability",
          subtitle: "Select a capability to enable for this restaurant",
          noAvailable: "All capabilities are already assigned",
          add: "Add",
        },
        addSuccess: "Capability added successfully",
        addError: "Failed to add capability",
        removeSuccess: "Capability removed successfully",
        removeError: "Failed to remove capability",
      },
      restaurantInfoPage: {
        restaurantInfo: {
          header: "Restaurant Information",
          subHeader: "Update your restaurant's information",
          subheader: "Manage your restaurant's basic details and settings",
          editCta: "Edit Information",
          sections: {
            basic: "Basic Information",
            basicSub: "Core details about your restaurant that customers will see",
            location: "Location",
            locationSub: "Where customers can find you",
            locationCta: "Restaurant location",
            capacity: "Capacity & Tags",
            capacitySub: "Help customers know what to expect",
            services: "Services & Amenities",
            servicesSub: "What services do you offer to customers?",
            social: "Social Media & Links",
            socialSub: "Connect your online presence",
          },
          ImportantInformation: {
            header: "Important Information",
            uploadSuccess: "Restaurant information updated successfully",
            uploadError:
              "An error occurred while updating the restaurant information",
            fields: {
              name: "Restaurant Name",
              address: "Address",
              city: "City",
              phone: "Phone Number",
              instagram_link: "Instagram Link",
              booze: "Do you serve alcohol?",
              animation: "Do you propose any animation?",
              quarter: "Street",
              numberOfSeats: "How many people can you accommodate?",
              numberOfSeatsHint: "How many people can your restaurant accommodate?",
              maximumPartySize: "Maximum party size",
              maximumPartySizePlaceholder: "No limit",
              maximumPartySizeHint:
                "The largest party you accept on a single booking. Leave empty for no limit.",
              tpe: "Do you accept payment by TPE?",
              tpeDesc: "Do you accept credit/debit card payments?",
              boozeDesc: "Do you serve alcoholic beverages?",
              animationDesc: "Do you offer live music, shows, or other entertainment?",
            },
          },
          seeMenuCta: "See the Restaurant Menu",
          cover: {
            header: "Cover Photo",
            replaceCover: "Replace cover",
            addCover: "Add a cover photo",
            uploadSuccess: "Cover photo uploaded successfully",
            uploadError: "An error occurred while uploading the cover photo",
          },
          tips: {
            title: "Tips",
            completeProfile: "A complete profile increases your restaurant's visibility",
            socialLinks: "Include your social links — customers check Instagram before visiting",
            capacity: "Accurate capacity helps customers plan group dinners with confidence",
            tags: "Adding accurate tags helps user find your restaurant easily",
          },
        },
        imageGallery: {
          header: "Restaurant Gallery",
          subHeader: "Provide a glimpse of your restaurant to your customers",
          uploadSuccess: "Images uploaded successfully",
          uploadError: "An error occurred while uploading the images",
        },
        menu: {
          images: {
            header: "Menu Gallery",
            subheader: "Showcase your dishes with stunning images",
            uploadSuccess: "Images uploaded successfully",
            uploadError: "An error occurred while uploading the images",
          },
          addSection: "Add a section",
          addDish: "Add a dish",
          save: "Save",
          section: {
            name: "Section name",
            itemName: "Dish name",
            itemDescription: "Dish description",
            itemPrice: "Dish price",
            uploadSuccess: "Menu updated successfully",
            uploadError: "An error occurred while updating the menu",
          },
        },
        hoursPicker: {
          header: "Opening Hours",
          subheader:
            "Set up your restaurant's opening and closing hours for each day of the week.",
          open: "From",
          close: "To",
          applyToAll: "Apply to all",
          typicalDay: "Typical Day",
          applyToAllDays: "Apply an opening to all days",
          registerMorning: "Register Morning Hours",
          registerAfternoon: "Register Afternoon Hours",
          uploadSuccess: "Opening hours updated successfully",
          uploadError: "An error occurred while updating the opening hours",
          switch: "Average booking duration",
        },
        leaveDays: {
          header: "Leave Days",
          subheader:
            "Inform your customers about the days your restaurant will be closed",
          addLeaveDay: "Add a leave day",
        },
        location: {
          header: "Restaurant Location",
          subheader:
            "Allow your customers to find your restaurant easily by providing your location",
          myPosition: "Take My Position",
          permissions:
            "You need to allow location permissions to use this feature",
          notSupported: "Geolocation is not supported by your browser",
          positionUnavailable: "Unable to retrieve your location",
          uploadSuccess: "Location updated successfully",
          uploadError: "An error occurred while updating the location",
        },
      },
    },
    bookings: {
      pageTitle: "Bookings",
      pageSubtitle: "Manage and track your restaurant reservations.",
      tips: {
        title: "Tips",
        responseTime: "Confirm or decline bookings within 1 hour to maintain a high response rate",
        notes: "Pay attention to the notes left by clients to flag special occasions",
        blacklist: "If a client has repeated no-shows you will be able to blacklist them",
      },
      createButton: "Create Booking",
      header: "Your Bookings",
      subheader: "Here are all the bookings made for your restaurants",
      stats: {
        todaysBookings: "Today's Bookings",
        todaysGuests: "Today's Guests",
        pending: "Pending",
        upcoming: "Upcoming",
        todaysNoShows: "Today's No-shows",
      },
      searchPlaceholder: "Search by name, email, or phone...",
      filters: {
        thisWeek: "This week",
        today: "Today",
        upcoming: "Upcoming",
        customRange: "Custom range",
        from: "From",
        to: "To",
        allStatuses: "All Statuses",
        sameDayOnly:
          "Your plan covers same-day bookings. Move to the Reservation module to manage future dates.",
      },
      list: {
        guests: "guests",
        table: "Table {{number}}",
        unassignedTable: "Unassigned",
        viewDetails: "View Details",
        noBookings: "No bookings found",
        noBookingsSubtitle: "Try adjusting your filters or create a new booking.",
        bookingsCount_one: "{{count}} booking",
        bookingsCount_other: "{{count}} bookings",
        bookingsCount: "{{count}} bookings",
      },
      status: {
        pending: "Pending",
        confirmed: "Confirmed",
        cancelled: "Cancelled",
        checkedIn: "Checked in",
        noShow: "No-show",
        updateError: "Couldn't update the booking status. Please try again.",
        actions: {
          confirm: "Confirm",
          cancel: "Cancel",
          checkIn: "Check in",
          noShow: "No-show",
          correctToCheckedIn: "Correct to checked in",
        },
      },
      whatsapp: {
        confirmLabel: "Confirm via WhatsApp",
        cancelLabel: "Cancel via WhatsApp",
        confirmMessage:
          "Hello {{guest}}, your booking at {{restaurant}} for {{seats}} guest(s) on {{date}} at {{time}} is confirmed. We look forward to welcoming you!",
        cancelMessage:
          "Hello {{guest}}, we are sorry to inform you that your booking at {{restaurant}} for {{seats}} guest(s) on {{date}} at {{time}} has been cancelled. Please contact us to arrange another date. We apologize for the inconvenience.",
      },
      noShowWarning: {
        chip_one: "{{count}} no-show · 30d",
        chip_other: "{{count}} no-shows · 30d",
        chip: "{{count}} no-shows · 30d",
      },
      blacklist: {
        title: "Block this guest?",
        body_one: "This guest has {{count}} no-show in the last 30 days. Block their future bookings at your restaurant?",
        body_other: "This guest has {{count}} no-shows in the last 30 days. Block their future bookings at your restaurant?",
        body: "This guest has {{count}} no-shows in the last 30 days. Block their future bookings at your restaurant?",
        dismiss: "Not now",
        confirm: "Blacklist",
      },
      table: {
        status: "Status",
        username: "Full Name",
        phone: "Phone Number",
        restaurant: "Restaurant",
        slot: "Slot",
        deal: "Deal",
        numberOfPeople: "Number of people",
        cancelBooking: "Cancel Reservation",
        confirmBooking: "Confirm Reservation",
        noBookings: "You have no bookings for this day",
      },
      modal: {
        confirm: {
          title: "Confirm Reservation",
          disclaimer: "Are you sure you want to confirm this reservation?",
        },
        cancel: {
          title: "Cancel Reservation",
          disclaimer: "Are you sure you want to cancel this reservation?",
        },
      },
      detailsModal: {
        title: "Booking Details",
        subtitle: "Full information for this reservation",
        date: "Date",
        time: "Time",
        partySize: "Party Size",
        phone: "Phone",
        email: "Email",
        deal: "Deal",
        close: "Close",
        createdAt: "Booking created {{date}}",
      },
      createModal: {
        title: "Create Booking",
        subtitle: "Add a new reservation for a customer.",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email Address",
        phone: "Phone Number",
        country: "Country",
        numberOfSeats: "Number of Guests",
        date: "Date & Time",
        notes: "Notes (optional)",
        submitButton: "Create Booking",
        success: "Booking created successfully",
        error: "Failed to create booking",
      },
    },
    tableSchedule: {
      pageTitle: "Floor Plan — Day Grid",
      tableLabel: "T{{number}}",
      tableLabelLong: "Table {{number}}",
      legend: {
        confirmed: "Confirmed",
        pending: "Pending",
        open: "Open hours",
        deal: "Deal",
        event: "Event",
      },
      tableCount: {
        label_one: "{{count}} table",
        label_other: "{{count}} tables",
        addHint: "Add a table",
        removeHint:
          "Remove the last table. Upcoming bookings seated there become unassigned.",
        error: "Could not update the number of tables. Please try again.",
      },
      unassigned: {
        title: "Unassigned bookings ({{count}})",
        hint: "Drag one onto the grid to seat it.",
        dropHere: "Drop here to free the table",
        empty: "No unassigned bookings — drag a booking here to free its table.",
      },
      placement: {
        instruction:
          "Pick any slot to place {{name}}'s booking — opening hours are not enforced.",
        cancel: "Cancel",
      },
      block: {
        continuesNextDay: "Runs into the next day",
        startedPrevDay: "Started the previous day",
      },
      inspector: {
        title: "Booking details",
        guest: "Guest",
        seats: "Guests",
        phone: "Phone",
        email: "Email",
        table: "Table",
        starts: "Starts",
        ends: "Ends",
        duration: "Duration",
        status: "Status",
        notes: "Notes",
        bookedBy: "Booked by",
        bookedByStaff: "Staff (added on the floor plan)",
        bookedByGuest: "Guest (online booking)",
        deal: "Deal",
        event: "Event",
        moveToDate: "Move to another date",
        spansMidnight:
          "This booking runs past midnight, so it shows on both days as one booking.",
        outsideOpening: "This slot sits outside the restaurant's opening hours.",
        cancelBooking: "Cancel booking",
        confirmCancel: "Yes, cancel it",
        cancelConfirm: "Cancel this booking? It will leave the floor plan.",
        cancelError: "Could not cancel the booking. Please try again.",
        confirmBooking: "Confirm booking",
        confirmError: "Could not confirm the booking. Please try again.",
        close: "Close",
      },
      moveError: "Could not move the booking. Please try again.",
      conflictError: "That table already has a booking at this time.",
      newBookingAt: "Table {{table}} · {{time}} · {{date}}",
      status: {
        CONFIRMED: "Confirmed",
        PENDING: "Pending",
        CANCELED: "Cancelled",
        CHECKED_IN: "Checked in",
        NO_SHOW: "No show",
      },
      setup: {
        title: "Set up your tables first",
        description:
          "Before you can assign bookings to tables, tell us how many tables your restaurant has. You can change this later.",
        inputLabel: "Number of tables",
        submit: "Save number of tables",
        error: "Something went wrong while saving. Please try again.",
        noPermission: "You don't have permission to configure the table count.",
      },
    },
    deals: {
      header: "Your Deals",
      subheader: "Consult the deals you have created for your restaurants",
      pageTitle: "Deals & Events",
      pageSubtitle: "Create and manage special offers and events for your restaurant.",
      tips: {
        title: "Tips",
        urgency: "Limited-time deals create urgency — keep them under 2 weeks for best results",
        multiSlot: "Events with multiple time slots get more engagement than single-slot ones",
        expiry: "Set the expiry date of deals to avoid customer disappointment",
        slowDays: "Pair deals with your slowest days to improve overall weekly revenue",
      },
      createButton: "Create Deal",
      edit: "Edit",
      event: "Event",
      deal: "Deal",
      active: "Active",
      inactive: "Inactive",
      empty: "No deals or events found",
      searchPlaceholder: "Search deals and events...",
      filterAll: "All",
      filterDeals: "Deals",
      filterEvents: "Events",
      stats: {
        total: "Total Deals & Events",
        activeNow: "Active Now",
        deals: "Deals",
        events: "Events",
      },
      modal: {
        createTitle: "Create New Deal",
        editTitle: "Edit Deal",
        subtitle: "Set up a new deal or event for your restaurant.",
        name: "Name",
        type: "Type",
        typeHint: "Deals are for special offers and discounts. Events are for special occasions and activities.",
        description: "Description",
        descriptionPlaceholder: "Describe the deal or event details...",
        dates: "Dates",
        selectedDates: "Selected Dates",
        timeSlots: "Time Slots",
        enableDeal: "Enable this deal",
        enableDealHint: "Disabled deals will not be shown to customers.",
        createButton: "Create Deal",
        selectDates: "Select date(s) or a range",
        addSlot: "Add",
      },
      addNewDeal: {
        header: "Create a new deal",
        editHeader: "Edit a deal",
        description: "Description of the deal",
        startTime: "Start Time",
        endTime: "End Time",
        addSlot: "Add a slot",
      },
      table: {
        status: "Status",
        description: "Description",
        restaurant: "Restaurant",
        type: "Type",
      },
      save: "Save",
      cancel: "Cancel",
      updateSuccess: "Deal updated successfully",
      updateError: "An error occurred while updating the deal",
    },
    statistics: {
      header: {
        title: "Executive Dashboard",
        chooseRestaurant: "Choose a restaurant",
        startDay: "Start Day",
        endDay: "End Day",
      },
      subheader: "Here are all the statistics for your restaurants",
      noStatistics: "You have no statistics for this day",
      visibilityKpi: {
        clickLabel: "Number of people who looked at your restaurant",
        bookingLabel: "Number of people who started the booking process",
        menuLabel: "Number of people who looked at your menu",
      },
      usersCountryKpi: {
        header: "Bookings by user origin",
        tourist: "Tourists",
        morrocan: "Locals",
      },
      bookingsByStatusKpi: {
        header: "Bookings grouped by status",
        pendingLabel: "Pending",
        confirmedLabel: "Confirmed",
        rejectedLabel: "Rejected",
      },
      bookingsKpiLabel: "Total Bookings",
      avgPartySize: "Average Party Size",
      occupancyLabel: "Occupancy Rate",
      seatsFilledLabel: "Seats Filled",
      visitorsLabel: "Number of clicks on your restaurant ",
      bookingsByStatus: {
        title: "Bookings by status",
        pending: "Pending",
        confirmed: "Confirmed",
        rejected: "Rejected",
        tooltip: "Number of bookings grouped by status",
      },
      bookingsTrendByDay: {
        title: "Bookings trend by day",
        tooltip: "Number of bookings per day",
        label: "Hour of the day",
      },
    },
    gallery: {
      title: "Media Gallery",
      subtitle: "Manage your restaurant and menu photos to attract more customers",
      editGallery: "Edit Gallery",
      cover: {
        title: "Cover Photo",
        subtitle: "This is the main image customers see on your restaurant page",
        currentlyDisplayed: "Currently Displayed",
        replaceCover: "Replace Cover",
        addCover: "Add Cover Photo",
      },
      restaurantTab: "Restaurant Gallery",
      menuTab: "Menu Gallery",
      restaurantPhotos: {
        title: "Restaurant Photos",
        subtitle: "Showcase your restaurant's atmosphere, interior, and exterior",
      },
      menuPhotos: {
        title: "Menu Photos",
        subtitle: "Display your dishes and drinks to entice customers",
      },
      uploadPhotos: "Upload Photos",
      addPhoto: "Add Photo",
      addPhotos: "Add Photos",
      noPhotos: "No photos yet",
      new: "New",
      tips: {
        title: "Photo Tips",
        quality: "Use high quality, well-lit photos (min. 1200×800px)",
        ambiance: "Show your restaurant's ambiance and signature dishes",
        seasonal: "Keep your gallery updated with seasonal offerings",
        people: "Encourage photos with people — they perform 3× better",
      },
      saveSuccess: "Gallery updated successfully",
      saveError: "Failed to update gallery",
    },
    menu: {
      pageTitle: "Menu Management",
      pageSubtitle: "Organise and manage your restaurant's menu items",
      tips: {
        title: "Tips",
        featured: "Feature your best-selling dishes with the star toggle to highlight them",
        reorder: "Drag items to reorder — put high-margin dishes near the top of each category",
        descriptions: "Keep descriptions concise: focus on ingredients and preparation style",
        freshness: "Menus updated regularly rank higher and attract more repeat visitors",
      },
      addItem: "Add Menu Item",
      addCategory: "Add Category",
      shareQr: "Share QR Code",
      qr: {
        title: "Public Menu QR Code",
        subtitle: "Print or download this code so guests can scan it to open your online menu.",
        print: "Print",
        download: "Download",
        scanHint: "Scan to view the menu",
      },
      searchPlaceholder: "Search menu items...",
      empty: "No menu items found",
      featured: "Toggle featured",
      currency: "MAD",
      filter: {
        allCategories: "All Categories",
        nCategories: "{{count}} categories",
      },
      stats: {
        totalItems: "Total Items",
        activeItems: "Active Items",
        categories: "Categories",
        avgPrice: "Avg. Price",
      },
      modal: {
        item: {
          title: "Add New Menu Item",
          editTitle: "Edit Menu Item",
          subtitle: "Fill in the details for your new menu item.",
          name: "Item Name",
          category: "Category",
          description: "Description",
          descriptionPlaceholder: "Describe the dish, ingredients, preparation...",
          price: "Price (MAD)",
          status: "Status",
          active: "Active",
          inactive: "Inactive",
          addButton: "Add Item",
          saveButton: "Save Changes",
        },
        category: {
          title: "Add New Category",
          subtitle: "Create a new category to organize your menu items.",
          name: "Category Name",
          placeholder: "e.g., Appetizers, Mains, Drinks",
          addButton: "Add Category",
        },
      },
    },
    analytics: {
      pageTitle: "Analytics",
      pageSubtitle: "Insights and metrics for your restaurant performance",
      dateRange: {
        thisWeek: "This Week",
        thisMonth: "This Month",
        thisYear: "This Year",
        custom: "Custom",
      },
      stats: {
        totalBookings: "Total Bookings",
        guestCount: "Guest Count",
        avgPartySize: "Avg. Party Size",
        occupancyRate: "Occupancy Rate",
        vsLastWeek: "vs last week",
        vsLastPeriod: "vs last period",
      },
      trend: {
        title: "Bookings & Guests Trend",
        subtitle: "Daily bookings and guest count over the selected period",
        bookings: "Bookings",
        guests: "Guests",
      },
      popularTimes: {
        title: "Popular Booking Times",
        subtitle: "Peak hours for reservations this week",
        hour: "Hour",
        bookings: "Bookings",
      },
      partySizeDistribution: {
        title: "Party Size Distribution",
        subtitle: "Breakdown by group size",
      },
      bookingSources: {
        title: "Booking Sources",
        subtitle: "Where customers find you",
      },
      dayOfWeek: {
        title: "Day of Week Performance",
        subtitle: "Capacity utilization by day",
        bookingsLabel: "{{count}} bookings ({{pct}}%)",
      },
      customerInsights: {
        title: "Customer Insights",
        subtitle: "Understanding your guests",
        newCustomers: "New Customers",
        newCustomersDesc: "First visit this week",
        returningCustomers: "Returning Customers",
        returningCustomersDesc: "Visited more than once",
        specialOccasions: "Special Occasions",
        specialOccasionsDesc: "Birthdays, anniversaries etc.",
      },
      performanceHighlights: {
        title: "Performance Highlights",
        subtitle: "This week's achievements",
      },
      offerPerformance: {
        dealsTitle: "Breakdown by deal × day",
        eventsTitle: "Breakdown by event × day",
        offerColumn: "Offer",
        weekTotal: "Covers",
        totalRow: "Total covers",
        newBadge: "New",
        weekdays: {
          mon: "Mon",
          tue: "Tue",
          wed: "Wed",
          thu: "Thu",
          fri: "Fri",
          sat: "Sat",
          sun: "Sun",
        },
      },
    },
    schedule: {
      title: "Opening Hours",
      subtitle: "Set your restaurant's opening and closing times for each day of the week",
      weeklySchedule: "Weekly Schedule",
      weeklyScheduleSub: "Configure opening hours for each day. Add afternoon/evening hours if you have a break period.",
      editSchedule: "Edit Schedule",
      open: "Open",
      closed: "Closed",
      openingTime: "Opening Time",
      closingTime: "Closing Time",
      addAfternoonEvening: "Add Afternoon/Evening Service",
      afternoonEvening: "Afternoon/Evening Service",
      markClosed: "Close This Day",
      markOpen: "Open This Day",
      applyToAll: "Apply to All",
      remove: "Remove",
      reservationDuration: "Reservation Duration",
      reservationDurationDesc: "Select the duration for each booking slot",
      duration1h: "1h",
      duration1h30: "1h30",
      duration2h: "2h",
      leaveDays: "Leave Days & Exceptions",
      leaveDaysSub: "Special days when your restaurant will be closed",
      noLeaves: "No leave days scheduled",
      leaveDay: "Leave Day",
      manageLeaves: "Manage Leave Days",
      bookingDuration: "Booking Duration Settings",
      bookingDurationSub: "How long should booking slots be for your restaurant?",
      allowDurationChanges: "Allow booking duration changes",
      allowDurationChangesDesc: "Let customers know they can leverage booking duration when booking",
      saveSuccess: "Schedule updated successfully",
      saveError: "Failed to update schedule",
      tips: {
        title: "Tips",
        holidays: "Update your hours before public holidays to prevent customer confusion",
        closures: "Mark special closures well in advance so customers can plan accordingly",
        bookingDuration: "Adjust the booking duration to ensure your table schedule remains coherent",
      },
    },
  },
};
